// store/agGridStateSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ColumnState, FilterModel } from "ag-grid-enterprise";
import { IRootState } from "./app/store";

export interface IAgGridSavedState {
  version?: number;
  columnsSignature?: string;
  quickFilter?: string;
  columnState?: ColumnState[] | null;
  filterModel?: FilterModel | null;
  pivotMode?: boolean;
  resetFilters?: boolean; // kontrollflagga
}

export type AgGridStateByKey = Record<string, IAgGridSavedState>;

export interface AgGridStateSlice {
  byKey: AgGridStateByKey;
}

const initialState: AgGridStateSlice = {
  byKey: {},
};

export const agGridStateSlice = createSlice({
  name: "agGridState",
  initialState,
  reducers: {
    rSetAgGridState: (
      state,
      action: PayloadAction<{ key: string; data: Partial<IAgGridSavedState> }>
    ) => {
      const { key, data } = action.payload;
      const prev = state.byKey[key] ?? {};
      state.byKey[key] = { ...prev, ...data };
    },
    rResetFiltersInAg: (state, action: PayloadAction<{ key: string }>) => {
      const { key } = action.payload;
      const prev = state.byKey[key] ?? {};
      state.byKey[key] = { ...prev, resetFilters: true };
    },
    rClearAgGridState: (state, action: PayloadAction<{ key: string }>) => {
      delete state.byKey[action.payload.key];
    },
  },
});

export const { rSetAgGridState, rResetFiltersInAg, rClearAgGridState } = agGridStateSlice.actions;

export default agGridStateSlice.reducer;

/**
 * Selector-factory:
 * Använd: const saved = useSelector(selectAgGridStateByKey(gridKey))
 */
export const selectAgGridStateByKey =
  (key: string) =>
  (state: IRootState): IAgGridSavedState =>
    state.agGrid.byKey[key] ?? {};
